module.exports = "<div class=\"page-spinner-bar\">\n    <div class=\"bounce1\"></div>\n    <div class=\"bounce2\"></div>\n    <div class=\"bounce3\"></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/ui/templates/spinner-bar.template.html
// module id = 1608
// module chunks = 7